import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { prepareBlockAsync, reportDWH , setCacheMinutes} from './ZoneFaultSlice';
import ProductsPage from './Partials/Pages/ProductsPage';
import StatusPage from './Partials/Pages/StatusPage';
import ErrorPage from './Partials/Pages/ErrorPage';
import NoServicePage from './Partials/Pages/NoServicePage';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { checkLoginData } from '../../Page/SelfCarePage/Utilities';
import { setRedirectUrl } from '../../../utilities/authentication/authenticationSlice';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../Config';
import { prepareUrl } from 'app/utilities/StringHelpers/StringHelpers';

const ZoneFaultMain = (props) => {
const isUserConnected = checkLoginData(props.authentication.loginData);
const cmsStatusList = props.iContent.statusTypes.expandedValue[0].statusListInfo.value;

const cmsTextData = {
  helptext: props.iContent?.helptext?.value,
  hotspotText: props.iContent?.hotspotText?.value,
  bottomText: props.iContent?.bottomText?.value,
  urlButtonText: props.iContent?.urlButtonText?.value,
  hotspotLink: props.iContent?.hotspotLink?.value,
  urlButton: props.iContent?.urlButton?.value,
  restartInternetText: props.iContent?.restartInternetText?.value,
  restartInternetLink: props.iContent?.restartInternetLink?.value,
  restartInternetLinkText: props.iContent?.restartInternetLinkText?.value,
  faultSendNotificationText: props.iContent?.faultSendNotificationText?.value,
  faultSendNotificationTextError: props.iContent?.faultSendNotificationTextError?.value,
};

  useEffect(() => {
    const cacheMinutes = props.iContent?.cacheMinutes?.value || 10;
    props.setCacheMinutes(cacheMinutes);
  }, []);

  useEffect(() => {
    if (props.authentication.isAuthenticateFinish) {
      if (isUserConnected) {
        props.prepareBlockAsync();
      } else {
        props.hideAppLoader();
        props.setRedirectUrl(window.location.pathname);
        EpiContext.navigateTo(Config.newLoginUrl);
      }
    }
  }, [props.authentication.isAuthenticateFinish]);

  useEffect(() => {
    if (props.page === 'errorPage') {
      props.reportDWH({ status: 'Error', messageText: 'General Error'});
    }
  }, [props.page]);

  let currentView = '';

  switch (props.page) {
    case 'productsPage':
      currentView = <ProductsPage />;
      break;
    case 'statusPage':
      currentView = <StatusPage cmsStatusList={cmsStatusList} cmsTextData={cmsTextData} />;
      break;
    case 'noServicePage':
      currentView = <NoServicePage />;
      break;
    case 'errorPage':
      currentView = <ErrorPage />;
      break;
  }

  return <div className='page-content'>{currentView}</div>;
};

const mapStateToProps = (state) => {
  return {
    page: state.zoneFaultBlock.page,
    authentication: state.authentication,
    banPsid: state.zoneFaultBlock.banPsid,
  };
};

const mapDispatchToProps = {
  prepareBlockAsync,
  showAppLoader,
  hideAppLoader,
  setRedirectUrl,
  reportDWH,
  setCacheMinutes
};

export default connect(mapStateToProps, mapDispatchToProps)(ZoneFaultMain);
